function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.56 12.17",
    style: {
      enableBackground: "new 0 0 17.56 12.17"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.83 6.05h12.35m-3.2-4.34 4.3 4.25-4.3 4.25",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.507,
      strokeLinecap: "square",
      strokeLinejoin: "round"
    }
  }));
};

export { SvgArrow as ReactComponent };
export default __webpack_public_path__ + "65fc5c892acba7083290ca343bd4f4d9.svg";